import { BadgeList } from "./Badges";
import {
  BADGE_TYPES,
  badgeTypeByRideType,
  badgeTypeByTransportTypeId,
} from "./badge-types";

export function RideDetailsBadges({ id, rideType, transportTypeId, hasInPersonPayment }) {
  return (
    <BadgeList>
      <BadgeList.Badge
        id={id}
        details={badgeTypeByTransportTypeId(transportTypeId)}
      />
      <BadgeList.Badge id={id} details={badgeTypeByRideType(rideType)} />
      {hasInPersonPayment && (
        <BadgeList.Badge id={id} details={BADGE_TYPES.IN_PERSON_PAYMENT} />
      )}
    </BadgeList>
  );
}

export function RideMetaBadges({
  id,
  hasStairs,
  isBariatric,
  isLongDistance,
  isInsurance,
}) {
  return (
    <>
      {(hasStairs || isBariatric || isLongDistance || isInsurance) && (
        <BadgeList>
          {isBariatric && (
            <BadgeList.Badge id={id} details={BADGE_TYPES.SPECIALIZED_TRANSPORT} />
          )}

          {hasStairs && (
            <BadgeList.Badge id={id} details={BADGE_TYPES.STAIRS} />
          )}

          {isLongDistance && (
            <BadgeList.Badge id={id} details={BADGE_TYPES.LONG_DISTANCE} />
          )}

          {isInsurance && (
            <BadgeList.Badge id={id} details={BADGE_TYPES.INSURANCE} />
          )}
        </BadgeList>
      )}
    </>
  );
}
